import dayjs from "dayjs";
import { EMPTY } from "./salesDashboard.constants";

export const SWR_OPTS = { revalidateOnFocus: false, shouldRetryOnError: false };

export const toRows = (payload) => {
  if (Array.isArray(payload?.results)) return payload.results;
  if (Array.isArray(payload?.data?.results)) return payload.data.results;
  if (Array.isArray(payload?.data)) return payload.data;
  return Array.isArray(payload) ? payload : [];
};

export const unwrapStats = (payload) => {
  if (!payload) return null;
  const inner = payload.data;
  return inner && typeof inner === "object" && !Array.isArray(inner) ? inner : payload;
};

export const pickNumber = (source, ...keys) => {
  for (const key of keys) {
    const value = source?.[key];
    if (value != null && value !== "") {
      const num = Number(value);
      if (Number.isFinite(num)) return num;
    }
  }
  return null;
};

export const formatCount = (value) => (value == null ? EMPTY : Number(value).toLocaleString("en-IN"));

export const formatDeltaBadge = (value, suffix) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  return `${num > 0 ? "+" : ""}${num.toLocaleString("en-IN")} ${suffix}`;
};

export const formatFollowupDue = (item) => {
  const date = item?.due_date || item?.due;
  if (!date) return EMPTY;
  const parsed = item?.due_time
    ? dayjs(`${date}T${item.due_time}`).isValid()
      ? dayjs(`${date}T${item.due_time}`)
      : dayjs(`${date} ${item.due_time}`)
    : dayjs(date);
  return parsed.isValid() ? parsed.format("DD MMM YYYY, h:mm a") : EMPTY;
};

export const leadStatusBadge = (raw) => {
  const key = String(raw || "")
    .trim()
    .toUpperCase()
    .replace(/[\s-]+/g, "_");
  const map = {
    NEW: { color: "gray", label: "NEW" },
    CONTACTED: { color: "blue", label: "CONTACTED" },
    FOLLOW_UP: { color: "orange", label: "FOLLOW UP" },
    PROPOSAL_SENT: { color: "orange", label: "PROPOSAL" },
    NEGOTIATION: { color: "yellow", label: "NEGOTIATION" },
    CLOSED_WON: { color: "green", label: "CLOSED WON" },
    CLOSED_LOST: { color: "red", label: "CLOSED LOST" },
  };
  return map[key] || { color: "gray", label: key.replace(/_/g, " ") || EMPTY };
};

export const priorityBadge = (raw) => {
  const key = String(raw || "").trim().toUpperCase();
  const colors = { CRITICAL: "red", HIGH: "orange", MEDIUM: "blue", LOW: "gray" };
  return { color: colors[key] || "gray", label: key || EMPTY };
};

export const personInitials = (name) => {
  const parts = String(name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return "?";
  return parts.length === 1
    ? parts[0].slice(0, 2).toUpperCase()
    : `${parts[0][0]}${parts[1][0]}`.toUpperCase();
};

export const leadName = (lead) => lead?.name || lead?.lead_name || lead?.person_name || "Lead";

export const followupPerson = (item) => item?.person_name || item?.lead_name || "Lead";

export const followupLeadNo = (item) =>
  item?.lead_no || (item?.lead ? `LID-${item.lead}` : EMPTY);
